const $ = (selector) => document.querySelector(selector);
const $$ = (selector) => document.querySelectorAll(selector);

/*
  Calcula el porcentaje de descuento
  @param string priceStr - Precio en formato string (ej: "$99.99")
  @param string compareAtPriceStr - Precio de comparación en formato string
  @return string - Porcentaje de descuento con formato "XX% OFF"
*/
const calculateDiscountPercentage = (priceStr, compareAtPriceStr) => {
  // Extraer valores numéricos de las cadenas de precio
  const price = parseFloat(priceStr.replace(/[^0-9.]/g, ''));
  const compareAtPrice = parseFloat(compareAtPriceStr.replace(/[^0-9.]/g, ''));
  
  if (!compareAtPrice || compareAtPrice === 0) return "0% OFF";
  
  const discount = ((compareAtPrice - price) / compareAtPrice) * 100;
  return Math.round(discount) + "% OFF";
}

/*
  @param Object newState "Objeto con modificaciones a remplezar el objeto state"
*/  
const setState = (newState, executed = true) => {
  state = {...state, ...newState};
  if(!executed){
    return;
  }
  subscriptions.map(subscription => {
    const nodeSets = subscription.elements.map(el => subscription.all ? $$(el) : [$(el)] );
    nodeSets.forEach(nodeSet => {
      if(nodeSet){
        nodeSet.forEach(node => {
          switch (subscription.type) {
            case "innerHtml":
              node.innerHTML = state.displayed[subscription.property];
              break;
            case "innerHTML_price":
              // Actualizar precio manteniendo el badge de descuento
              const discountBadge = node.querySelector('[data-custom-percentage-discount]');
              if (discountBadge) {
                const discountHTML = discountBadge.outerHTML;
                node.innerHTML = state.displayed[subscription.property] + '\n          ' + discountHTML;
              } else {
                node.innerText = state.displayed[subscription.property];
              }
              break;
            case "innerText":
              node.innerText = state.displayed[subscription.property];
              break;
            case "setAttribute":
              node.setAttribute(subscription.attribute, state.displayed[subscription.property]);
              break;
            case "toggle":
              if(state.displayed[subscription.property] == ""){
                node.classList.remove(subscription.attribute);
              }
              if(state.displayed[subscription.property] != ""){
                node.classList.add(subscription.attribute);
              }
              break;
            case "img":
              node.src = state.displayed[subscription.property];
              node.setAttribute("data-src", state.displayed[subscription.property]);
            default:
              node.innerText = state.displayed[subscription.property];
              break;
          }
        });
      }
    });
  });
}



/* Cambia el state por opcion del kit seleccionado
  @param string kitName 
*/
const onClickKitsOption = (kitName) => {
  const kitFilter = getKitSelected(kitName);
  if(!kitFilter.pants){
    lastOption = "None"
    setState({
      ...state,
      selection: {
        ...state.selection,
        ...(state?.selection?.[2] != undefined && { [2]: "None" })
      },
      displayed: {
        ...state.displayed,
        data_sizes_2: ""
      }
    });
  }

  setState({
    ...state,
    selection: {
      ...state.selection,
      [0]: kitName
    }
  });
  
  variantFilter = getVariantSelected();
  const soldout = getAnyAvailable();

  restartSizeOption();
  soldoutSize(1, state.selection[1]);
  
  // Calcular porcentaje de descuento
  const currentPrice = state.subscription ? kitFilter.subscription.price_money : kitFilter.one_time.price_money;
  const currentComparePrice = state.subscription ? kitFilter.subscription.compare_at_price_money : kitFilter.one_time.compare_at_price_money;
  const discountPercentage = calculateDiscountPercentage(currentPrice, currentComparePrice);
  
  setState({
    ...state,
    displayed: {
      ...state.displayed,
      variant_id: state.subscription ? kitFilter.subscription.id : kitFilter.one_time.id,
      price: state.subscription ? kitFilter.subscription.price_money : kitFilter.one_time.price_money,
      price_one_time_pay: kitFilter.one_time.price_money_pay,
      compare_at_price: state.subscription ? kitFilter.subscription.compare_at_price_money : kitFilter.one_time.compare_at_price_money,
      custom_percentage_discount: discountPercentage,
      price_subscription: kitFilter.subscription.price_money,
      price_one_time: kitFilter.one_time.price_money,
      title: kitFilter.custom_title,
      description: kitFilter.description,
      pants_size: kitFilter.pants ? "" : "is-hidden",
      selling_fast: kitFilter.selling_fast ? "" : "is-hidden",
      kit_description: state.subscription ? kitFilter.subscription.kit_description : kitFilter.one_time.kit_description,
      save_price: state.subscription ? kitFilter.subscription.save_price : kitFilter.subscription.save_price,
      variant_subscription_id: kitFilter.subscription.id,
      variant_one_time_id: kitFilter.one_time.id,
      sold_out: !soldout,
      btn_cta: soldout ? "ADD TO CART" : "SOLD OUT"
    }
  });

  changeUrlVariantId();
  changeSwiperMedia(kitFilter.media);
  if(!kitFilter.pants && 2 in state.selection){
    $$(`[name="swatch_size_input_2"]`).forEach( (option) => {
      if(option.checked){
        option.checked = false;
      }
    });
  }
}

/*Size Option*/
const onClickSizeOption = (index, size) => {
  $(`[data-options-error-${index}]`).classList.add("is-hidden");
  /*Actualiza la opcion seleccionada*/
  setState({
    ...state,
    selection: {
      ...state.selection,
      [index]: size
    }
  }, false);
  
  /*Obtiene la variante seleccionada*/
  const kitFilter = getKitSelected(state.selection[0]);

  // const sizeMeasure = filterMeasures(index, size);
  // const measure = `data_sizes_${index}`;

  variantFilter = getVariantSelected();
  let soldout = getAnyAvailable(index);
  if(index == 1){
    if(state.selection[2] != "None"){
      soldout = state.subscription ? variantFilter.subscription.available : variantFilter.one_time.available;
    }
    soldoutSize(index, size);
  }
  if(index == 2){
    soldout = state.subscription ? variantFilter.subscription.available : variantFilter.one_time.available;
    soldoutSize(index, size);
  }

  /*Actualiza la url*/
  changeUrlVariantId();
  
  // Calcular porcentaje de descuento
  const currentPrice = state.subscription ? kitFilter.subscription.price_money : kitFilter.one_time.price_money;
  const currentComparePrice = state.subscription ? kitFilter.subscription.compare_at_price_money : kitFilter.one_time.compare_at_price_money;
  const discountPercentage = calculateDiscountPercentage(currentPrice, currentComparePrice);
  
  /*Actualiza el contenido HTML*/
  setState({
    ...state,
    displayed: {
      ...state.displayed,
      price: state.subscription ? kitFilter.subscription.price_money : kitFilter.one_time.price_money,
      compare_at_price: state.subscription ? kitFilter.subscription.compare_at_price_money : kitFilter.one_time.compare_at_price_money,
      custom_percentage_discount: discountPercentage,
      price_subscription: kitFilter.subscription.price_money,
      price_one_time: kitFilter.one_time.price_money,
      sold_out: !soldout,
      btn_cta: soldout ? "ADD TO CART" : "SOLD OUT"
    }
  });
  /*Actualiza toda la galeria*/
  changeSwiperMedia(kitFilter.media);
  /*Actualiza el contenido de las cards de kits*/
  state.kits_options.values.map((option, index) => {
    /*Obtiene la variante de la card*/
    variantFilter = getVariantSelected(option);
    const keyMedia = `kit_media_${index + 1}`;
    /*Actualiza el contenido de la card*/
    setState({
      ...state,
      displayed: {
        ...state.displayed,
        [keyMedia]: state.subscription ? variantFilter.subscription.src : variantFilter.one_time.src
      }
    });
  });
}


const soldoutSize = (index, size) => {
  const labelSizeOption = $(`[data-${index}-${size}]`);
  if(labelSizeOption){
    !getAnyAvailable(index) ? labelSizeOption.classList.add("soldout") : labelSizeOption.classList.remove("soldout");
  }
}

const getAnyAvailable = (index = 1) => {
  return state.variants.filter(variant => {
    const parts = variant.title.split('/').map(v => v.trim());
    return parts[0] == state.selection[0] && parts[index] == state.selection[index];
  }).filter(
    variant => state.subscription ? variant.subscription.available : variant.one_time.available
  ).reduce((acc, variant) => {
    return acc || state.subscription ? variant.subscription.available : variant.one_time.available;
  }, false);
}

const restartSizeOption = () => {
  $$('.swatch_size__options label').forEach((item) => {
    item.classList.remove("soldout");
  });
}

const filterMeasures = (index, size) => {
  index = index-1;
  const sizeIndex = sizeGuideJson[index].sizes.indexOf(size);
  const measures = sizeGuideJson[index].measures.map(measure => `<b>${measure.name}</b> ${measure.sizes[sizeIndex]}`).join(' ');
  return `<p>${measures}</p>`;
}

/* subscription - one-time */
const onClickSubscription = (type) => {
  setState({
    ...state,
    subscription: type == 'subscription' ? true : false,
  });
  /*Obtiene la variante*/
  const kitFilter = getKitSelected(state.selection[0]);
  /*Actualiza la url*/
  changeUrlVariantId();
  
  // Calcular porcentaje de descuento
  const currentPrice = state.subscription ? kitFilter.subscription.price_money : kitFilter.one_time.price_money;
  const currentComparePrice = state.subscription ? kitFilter.subscription.compare_at_price_money : kitFilter.one_time.compare_at_price_money;
  const discountPercentage = calculateDiscountPercentage(currentPrice, currentComparePrice);
  
  /*Actualiza el contenido HTML*/
  setState({
    ...state,
    displayed: {
      ...state.displayed,
      price: state.subscription ? kitFilter.subscription.price_money : kitFilter.one_time.price_money,
      compare_at_price: state.subscription ? kitFilter.subscription.compare_at_price_money : kitFilter.one_time.compare_at_price_money,
      custom_percentage_discount: discountPercentage,
      first_media: state.subscription ? kitFilter.subscription.src : kitFilter.one_time.src,
      first_media_thumb: state.subscription ? kitFilter.subscription.src : kitFilter.one_time.src,
      kit_description: state.subscription ? kitFilter.subscription.kit_description : kitFilter.one_time.kit_description,
      variant_id: state.subscription ? kitFilter.subscription.id : kitFilter.one_time.id,
      variant_subscription_id: state.subscription ? kitFilter.subscription.id : kitFilter.one_time.id,
      variant_one_time_id: kitFilter.one_time.id,
    }
  });
  /*Actualiza toda la galeria*/
  changeSwiperMedia(kitFilter.media);
  /*Actualiza el contenido de las cards de kits*/
  state.kits_options.values.map((option, index) => {
    /*Obtiene la variante de la card*/
    const kitFilterOption = getKitSelected(option);
    variantFilter = getVariantSelected(option);
    if(kitFilterOption){
      const keyMedia = `kit_media_${index + 1}`;
      const keyPrice = `kit_price_${index + 1}`;
      const keyAtPrice = `kit_compare_at_price_${index + 1}`;
      const keySavePrice = `kit_save_price_${index + 1}`;
      const keyPercentage = `kit_percentage_${index + 1}`;
      const keyVariantId = `kit_variant_id_${index + 1}`;
      /*Actualiza el contenido de la card*/
      setState({
        ...state,
        displayed: {
          ...state.displayed,
          [keyVariantId]: state.subscription ? kitFilterOption.subscription.id : kitFilterOption.one_time.id,
          [keyPrice]: state.subscription ? kitFilterOption.subscription.price_money : kitFilterOption.one_time.price_money,
          [keyAtPrice]: state.subscription ? kitFilterOption.subscription.compare_at_price_money : kitFilterOption.one_time.compare_at_price_money,
          [keySavePrice]: state.subscription ? kitFilterOption.subscription.save_price_money : kitFilterOption.one_time.save_price_money,
          [keyPercentage]: state.subscription ? kitFilterOption.subscription.percentage : kitFilterOption.one_time.percentage,
          [keyMedia]: state.subscription ? variantFilter.subscription.src : variantFilter.one_time.src
        },
      });
    }
  });
}

/*Submit Float*/
const onSubmitFloat = () => {
  const swatch = $(".swatch_kit.bundle_cards");
  swatch.scrollIntoView({ behavior: 'smooth', block: 'start' });
  onSubmit();
}

const onSubmit = () => {
  /* Validacion Submit */
  allInputChecked = true;
  Object.values(state.selection).map( (textOption, index) => {      
    let notExistChecked = true;
    $$(`[name="swatch_size_input_${index}"]`).forEach( (option) => {
      if(option.checked){
        notExistChecked = false;
      }
      if(option.value == "None" && index == 2){
        notExistChecked = true;
      }
    });
    if(2 in state.selection){
      if(state.kits_options.values[2] != state.selection[0] && index == 2){
        notExistChecked = false;
      }
    }
    const pElementError = $(`[data-options-error-${index}]`);
    if(notExistChecked && pElementError){
      allInputChecked = false;
      pElementError.classList.remove("is-hidden");
      pElementError.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    return { notExistChecked, pElementError, index};
  });
  if(!allInputChecked){
    return;
  }
  const variantFilter = getVariantSelected();
  const variantId = state.subscription ? variantFilter.subscription.id : variantFilter.one_time.id;
  const purchaseType = state.subscription ? "subscription_product" : "one-time";

  const inputDiscount = $("[data-discount-form]");
  const discountValue = (inputDiscount && inputDiscount.name != "") ? inputDiscount.value : undefined;

  const productParams = {
    id: variantId,
    quantity: 1,
    properties: {"_purchase_type": purchaseType},
    ...(discountValue && { 'attributes[discount]': discountValue }),
    ...(state.subscription && { 'selling_plan': state.selling_plan })
  }
  items = [productParams]

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
        "Content-Type": "application/json",
    },
    body: JSON.stringify({
        items
    }),
  }).then(data => {
  })
  .catch(error => {
    console.error('Error:', error.message);
  })
  .finally(function () {
    openCart();
  });
}

/* Retorna el kit seleccionado en el state filtrado por el kitName
  @param string kitName
*/
const getKitSelected = (kitName) => {
  const kitFilter = state.kits.find(variant => {
    const parts = variant.title.split('/').map(v => v.trim());
    return parts[0] == kitName
  });
  return kitFilter
}

/*
  Retorna la variante seleccionada filtrada por la seleccion dentro de state.selection
*/
const getVariantSelected = (kitName = undefined) => {
  if(!kitName){
    kitName = state.selection[0];
  }
  if(2 in state.selection){
    lastOption = state.selection[2];
  }
  const kitFilter = getKitSelected(kitName);
  if(!kitFilter.pants){
    lastOption = "None"
  }

  let variantFilter = state.variants.find(variant => {
    const parts = variant.title.split('/').map(v => v.trim());
    if(2 in state.selection){
      return parts[0] == kitName && parts[1] == state.selection[1] && parts[2] == lastOption;
    }else if(1 in state.selection) {
      return parts[0] == kitName && parts[1] == state.selection[1]
    }
  });

  $(`[name="id"]`).value = state.subscription ? variantFilter.subscription.id : variantFilter.one_time.id;

  return variantFilter
}

/*Url Update*/
const changeUrlVariantId = () => {
  variantFilter = getVariantSelected();
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('variant')) {
    urlParams.set('variant', variantFilter.one_time.id);
  } else {
    urlParams.append('variant', variantFilter.one_time.id);
  }
  const url = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${urlParams.toString()}`;
  window.history.replaceState({}, '', url);
}
/*
  Recibe un arreglo con la galeria a sobrescribir
  @param mediaContent array
  Contiene la variante seleccionada con la imagen de la talla
  @var variantFilter object
*/
const changeSwiperMedia = (mediaContent) => {
  const variantFilter = getVariantSelected();
  const oldSliderSwiper = $(".product_media__slider .swiper-wrapper");
  const oldSliderThumbSwiper = $(".product_media__slider_thumbs .swiper-wrapper");

  let mediaSlider = '';
  let mediaSliderThumbs = '';

  state.selection[0]
  state.kits_options

  let filterSize = dataSizesTitles.find( (item) => {
    return item.type == state.selection[1] && item.index == Array.from(state.kits_options.values).findIndex(item => item == state.selection[0]);
  });
  const spanText = filterSize ? `<span class="wears_size">${filterSize.title}</span>` : '';
  let imgSeller = '';
  if(state.kits_options.values[0] == state.selection[0] || state.kits_options.values[1] == state.selection[0]){
    imgSeller = imgSticker;
  }
  const src = state.subscription ? variantFilter.subscription.src : variantFilter.one_time.src;
  const src50 = state.subscription ? variantFilter.subscription.src : variantFilter.one_time.src;
  const imgText = `<img class="image lazyload responsive-img" data-src="${src}" src="${src}" width="600px" height="600px" loading="lazy"/>`;
  const imgTextThumb = `<img class="image lazyload responsive-img" data-src="${src50}" src="${src50}" width="50px" height="50px" />`;
  mediaSlider = `${mediaSlider}<div class="product_media__object swiper-slide">${spanText}${imgText}${imgSeller}</div>`;
  mediaSliderThumbs = `${mediaSliderThumbs}<div class="product_media__object swiper-slide">${imgTextThumb}</div>`;

  mediaContent.map((media, index) => {
    if(media.type == "image"){
      const imgText = `<img class="image lazyload responsive-img" data-src="${media.src}" src="${media.src}" width="600px" height="600px" loading="lazy"/>`;
      const imgTextThumb = `<img class="image lazyload responsive-img" data-src="${media.src}" src="${media.src}" width="50px" height="50px" loading="lazy"/>`;
      mediaSlider = `${mediaSlider}<div class="product_media__object swiper-slide">${imgText}</div>`;
      mediaSliderThumbs = `${mediaSliderThumbs}<div class="product_media__object swiper-slide">${imgTextThumb}</div>`;
    }
    if(media.type == "video"){
      mediaSlider = `${mediaSlider}<div class="product_media__object swiper-slide"><video class="responsive-video"  loop  muted  autoplay  playsinline  src="${media.src}"  poster="${window.location.origin}/${media.poster}" muted="true"  playsinline="playsinline"></video></div>`
      mediaSliderThumbs = `${mediaSliderThumbs}<div class="product_media__object swiper-slide"><video class="responsive-video"  loop  muted  autoplay  playsinline  src="${media.src}"  poster="${window.location.origin}/${media.poster}" muted="true"  playsinline="playsinline"></video></div>`
    }
  });
  oldSliderSwiper.innerHTML = mediaSlider;
  oldSliderThumbSwiper.innerHTML = mediaSliderThumbs;
  sliderMedia.update();
  sliderMedia.slideTo(0);
}

const productSection = $('.product_buttons__submit');
const floatCta = $('.float_btn_container');

/*CTA Float*/
const handleScroll = () => {
  const rect = productSection.getBoundingClientRect();
  const isVisible = rect.top >= 0;
  const wizybotElement = $("div#wizydiv iframe");
  const klaviyoPopPup = $(".needsclick");
  let distanceWizy = "10px";
  if (window.innerWidth <= 1023) {
    if (!isVisible) {
      let distanceWizy = "70px";
      floatCta.classList.remove('is-hidden');
      wizybotElement ? wizybotElement.style.bottom = distanceWizy : undefined;
      klaviyoPopPup ? klaviyoPopPup.style.bottom = distanceWizy : undefined;
    } else {
      floatCta.classList.add('is-hidden');
      wizybotElement ? wizybotElement.style.bottom = distanceWizy : undefined;
      klaviyoPopPup ? klaviyoPopPup.style.bottom = distanceWizy : undefined;
    }
  }
}
const handleValidateRecurrentProduct = (variantId) => {
  let resultValidation = true;
  const existInRecurrent = variantsRecurrentProduct.find( (item) => item.variant_id == variantId );
  let existInCart = undefined;
  if(window?.Rebuy?.SmartCart?.items()){
    existInCart = window.Rebuy.SmartCart.items().find((itemCart) => variantsRecurrentProduct.find( (itemVariant) => itemVariant.id == itemCart.id ));
  }else{
    existInCart = variantsCart.find((itemCart) => variantsRecurrentProduct.find( (itemVariant) => itemVariant.id == itemCart.id ));
  }
  if(existInRecurrent && existInCart){
    resultValidation = false;
  }
  return resultValidation;
}

let sliderMedia;

document.addEventListener('DOMContentLoaded', ()=> {
  /*Swiper Gallery*/
  sliderThumbs = new Swiper(".product_media__slider_thumbs", {
    breakpoints: {
      320: {
        direction: 'horizontal',
        slidesPerView: 'auto',
        spaceBetween: 10,
      },
      1023: {
        direction: 'vertical',
        slidesPerView: 'auto',
        spaceBetween: 10,
      },
    }, 
    a11y: {
      enable: false,
    },
    spaceBetween: 10,
    slidesPerView: 'auto',
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    centerInsufficientSlides: false
  });
  
  sliderMedia = new Swiper('.product_media__slider', {
    a11y: {
      slideRole: 'group',
    },
    navigation: {
      nextEl: ".product-gallery__navigation .swiper-button-next",
      prevEl: ".product-gallery__navigation .swiper-button-prev",
    },
    thumbs: {
      swiper: sliderThumbs,
    },
  });
  new Swiper('.product-sw__info__videos-gallery', {
    slidesPerView: "3",
    spaceBetween: 15,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    a11y: {
      slideRole: 'none',
    }
  });
  videosSlider = new Swiper('.product-sw__modal-videos__slider', {
    slidesPerView: 1,
    direction: 'vertical',
    navigation: {
      nextEl: '.product-sw__modal-videos__slider .swiper-button-next',
      prevEl: '.product-sw__modal-videos__slider .swiper-button-prev',
    },
    a11y: {
      slideRole: 'none',
    }
  });
  videosSlider.on('slideChange', function (e) {
    const slider = e.el;
    const slides = slider.querySelectorAll('.product-sw__modal-videos__slider__slide');
    slides.forEach((slide, index) => {
      slide.classList.add('muted');
      slide.querySelector('.video-slide').muted = true;
      slide.querySelector('button').classList.add('muted');
    });
  });
  /*End Swiper*/
  handleScroll();
  window.addEventListener('scroll', () => {
    handleScroll();
  });
});

const closeModalSize = (index) => {
  const sizemodal = $(`#sizes-modal-${index}`);
  const isClosing = sizemodal && !sizemodal.classList.contains("is-hidden");
  sizemodal ? sizemodal.classList.toggle("is-hidden") : undefined;
  const overlay = $(`#sizes-modal-overlay-${index}`);
  overlay ? overlay.classList.toggle("is-hidden") : undefined;

  if (isClosing && sizemodal) {
    sizemodal.querySelectorAll("video").forEach((video) => {
      video.pause();
      video.currentTime = 0;
    })
  }
}
const handleModalSizeGuide = (index) => {
  const sizemodal = $(`#sizes-modal-${index}`);
  sizemodal ? sizemodal.classList.toggle("is-hidden") : undefined;
  const overlay = $(`#sizes-modal-overlay-${index}`);
  overlay ? overlay.classList.toggle("is-hidden") : undefined;
}


const videosModal = $('.product-sw__modal-videos');
const videosModalWrapper = videosModal.querySelector('.swiper-wrapper');
const handleClickShowVideosGallery = (indexVideo) => {
  const realIndex = indexVideo - 1;
  videosModal.classList.add('is-active')
  videosSlider.update()
  videosSlider.slideTo(realIndex)
}
const closeShowModalVideos = () => {
  videosModal.classList.remove('is-active')
  videosModalWrapper.querySelectorAll('.video-slide').forEach((video) => {
    video.muted = true
  })
}
const handleOnSoundVideo = (event) => {
  const containers = $$(".product-sw__modal-videos__slider .product-sw__modal-videos__slider__slide");
  const currentContainer = event.target.closest(".product-sw__modal-videos__slider__slide")
  const currentVideo = currentContainer.querySelector("video")
  const currentBtn = currentContainer.querySelector("button")
  containers.forEach(container => {
    const video = container.querySelector("video")
    const btn = container.querySelector("button")
    if (video !== currentVideo) {
      btn.classList.add("muted")
      video.muted = true
    }
  })
  currentBtn.classList.toggle("muted")
  currentVideo.muted = !currentVideo.muted;
}